import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Companies from './pages/Companies'
import CompanyProfile from './pages/CompanyProfile'
import AddEditCompany from './pages/Companies/AddEditCompany'
import customerAdminUsers from './pages/Users/customerAdminUsers'
import SysAdminAddEditUser from './pages/Users/SystemAdminUsers/AddEditUsers'
import CustomerAdminAddEditUser from './pages/Users/customerAdminUsers/AddEditUsers'
import NoMatch from './pages/Errors/404'
import NotAuthorized from './pages/Errors/NotAuthorized'
import userProfile from './pages/userProfile'
import Login from './pages/Auth/Login'
import Consent from './pages/Auth/Consent'
import ResetPassword from './pages/Auth/ResetPassword'
import ForgetPassword from './pages/Auth/ForgetPassword'
import AppRoutes from './services/AppRoutes'
import AuthRoute from './services/AuthRoute'
import PublicRoute from './services/PublicRoute'
import Landing from './pages/Landing'
import FirstTimePassword from './pages/Auth/FirstTimePassword'
import SamlCallback from './pages/Auth/SamlDomain/SamlCallback'
import SamlErrorPage from './pages/Auth/SamlDomain/samlError/SamlErrorPage'
import UsersBatchActionsStatus from './pages/UsersBatchActionsStatus'
import ActionStatusDetails from './pages/UserBatchActionStatusDetail'
import NotificationInbox from './pages/Notification/NotificationInbox'
import ActionHistory from './pages/Notification/ActionHistory'
import NotificationCenter from './pages/Notification/NotificationCenter'
import AccessDenied from './pages/Errors/403'
import ImportUsersRoles from './pages/ImportUsersRoles'
import ImportUsersRolesDetail from './pages/ImportUsersRolesDetail'
import DisabledUser from './pages/Errors/DisabledUser'
import SystemAdminUsers from './pages/Users/SystemAdminUsers'
import Settings from './pages/Settings'

const Routes = () => (
  <Switch>
    <PublicRoute exact path={AppRoutes.notAuthorized} component={NotAuthorized} />
    <PublicRoute
      exact
      path={AppRoutes.accessDenied}
      component={AccessDenied}
      appBarProps={({ isAuthenticated }) => ({ onlyLogo: !isAuthenticated })}
    />

    <PublicRoute exact path={AppRoutes.disabledUser} component={DisabledUser}/>

    <PublicRoute exact path={AppRoutes.samlCallback} component={SamlCallback} guestOnly/>
    <PublicRoute exact path={AppRoutes.samlError} component={SamlErrorPage} guestOnly/>
    <PublicRoute exact path={AppRoutes.forgotPassword} component={ForgetPassword} guestOnly />
    <PublicRoute exact path={AppRoutes.resetPassword} component={ResetPassword} guestOnly />

    <PublicRoute exact path={AppRoutes.login} component={Login} guestOnly withAppBar={false} />

    <AuthRoute
      exact
      path={AppRoutes.consent}
      component={Consent}
      withAppBar
      appBarProps={{ onlyLogo: true }}
    />

    <AuthRoute
      exact
      path={AppRoutes.userProfile}
      sysAdminComponent={userProfile}
      csAdminComponent={userProfile}
    />

    <AuthRoute
      exact
      path={AppRoutes.home}
      sysAdminComponent={Companies}
      csAdminComponent={customerAdminUsers}
    />

    <AuthRoute exact path={AppRoutes.companyProfile} sysAdminComponent={CompanyProfile} />

    <AuthRoute exact path={AppRoutes.addCompany} sysAdminComponent={AddEditCompany} />

    <AuthRoute exact path={AppRoutes.editCompany} sysAdminComponent={AddEditCompany} />

    <AuthRoute
      exact
      path={AppRoutes.adduser}
      sysAdminComponent={SysAdminAddEditUser}
      csAdminComponent={CustomerAdminAddEditUser}
    />
    <AuthRoute
      exact
      path={AppRoutes.editUser}
      sysAdminComponent={SysAdminAddEditUser}
      csAdminComponent={CustomerAdminAddEditUser}
    />

    <AuthRoute exact path={AppRoutes.users} sysAdminComponent={SystemAdminUsers} />

    <AuthRoute
      exact
      path={AppRoutes.usersBatchActionsStatus}
      csAdminComponent={UsersBatchActionsStatus}
    />

    <AuthRoute exact path={AppRoutes.importUsersRoles} csAdminComponent={ImportUsersRoles} />

    <AuthRoute
      exact
      path={AppRoutes.importUsersRolesDetail}
      csAdminComponent={ImportUsersRolesDetail}
    />

    <AuthRoute path={AppRoutes.actionStatusDetails} csAdminComponent={ActionStatusDetails} />

    <Route path={AppRoutes.firstTimePassword} component={FirstTimePassword} />

    <AuthRoute path={AppRoutes.landing} component={Landing} />

    <AuthRoute
      exact
      path={AppRoutes.notificationCenter}
      component={NotificationCenter}
      withAppBar
    />
    <AuthRoute exact path={AppRoutes.NotificationInbox} component={NotificationInbox} withAppBar />

    <AuthRoute exact path={AppRoutes.ActionHistory} component={ActionHistory} withAppBar />

    <AuthRoute exact path={AppRoutes.settings} component={Settings} withAppBar />

    <PublicRoute path="*" component={NoMatch} />
  </Switch>
)

export default Routes
